import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import { Form, Formik } from 'formik'
import { SubmitButton, Input, FormWideErrorReporter } from 'formik-components'
import PropTypes from 'prop-types'
import * as Yup from 'yup'
import { LOGIN_TYPE } from '../../types'

const propTypes = {
  initialValues: PropTypes.object.isRequired,
  onSubmit: PropTypes.func.isRequired,
}

const defaultProps = {}

const VALIDATION_SCHEMA = Yup.object({
  email: Yup.string()
    .email('Email must be valid')
    .required("Email can't be blank"),
  password: Yup.string().required("Password can't be blank"),
})

function LogInForm({ initialValues, onSubmit }) {
  const [loginType, setLoginType] = useState(LOGIN_TYPE.TECHNICIAN)

  const LOGIN_MODE_OPTIONS = [
    { label: 'Technician', value: LOGIN_TYPE.TECHNICIAN },
    { label: 'Account Manager Portal', value: LOGIN_TYPE.MANAGER },
  ]

  const handleSubmit = async (values) => {
    await onSubmit({ ...values, loginType: loginType })
  }

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={VALIDATION_SCHEMA}
      onSubmit={handleSubmit}
      validateOnBlur={false}
    >
      {({ isSubmitting }) => {
        return (
          <Form>
            <FormWideErrorReporter />
            <fieldset className="input-container" data-login-mode={loginType}>
              <div className="radio-group">
                {LOGIN_MODE_OPTIONS.map(({ label, value }) => (
                  <div key={value} className="radio-option">
                    <input
                      type="radio"
                      id={`login-mode-${value}`}
                      name="loginType"
                      value={value}
                      checked={loginType === value}
                      onChange={(e) => setLoginType(Number(e.target.value))}
                    />
                    <label htmlFor={`login-mode-${value}`}>{label}</label>
                  </div>
                ))}
              </div>
            </fieldset>
            <Input
              name="email"
              label="Email"
              type="email"
              required={true}
              requiredIndicator="*"
              placeholder="Enter email address"
              dataTest="email"
            />
            <Input
              name="password"
              label="Password"
              type="password"
              required={true}
              requiredIndicator="*"
              placeholder="Enter password"
              dataTest="password"
            />
            {loginType === LOGIN_TYPE.MANAGER && (
              <Input
                name="pin"
                label="PIN"
                type="password"
                required={true}
                requiredIndicator="*"
                placeholder="Enter PIN"
                dataTest="pin"
              />
            )}
            <div className="forgot-pass-link">
              <Link to="/auth/forgotpassword">
                <b>Forgot your password?</b>
              </Link>
            </div>
            <SubmitButton
              isSubmitting={isSubmitting}
              buttonClassName="login-submit-btn"
            >
              Log In
            </SubmitButton>
          </Form>
        )
      }}
    </Formik>
  )
}

LogInForm.propTypes = propTypes
LogInForm.defaultProps = defaultProps

export default React.memo(LogInForm)
